module.exports = __webpack_public_path__ + "static/logo-cacff25f10d7a4a8af46c81883077199.png";